// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_personal_tokens_model from "./web_personal_tokens_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

const endpoint = "/api/personal-access-tokens";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function failure(t, error) {
  if (!/* tag */ (typeof error !== "object" && typeof error !== "function")) {
    return Curry._1(t.emit, {
      TAG: /* Personal_tokens */ 40,
      _0: {
        TAG: /* Failed */ 9,
        _0: error._0
      }
    });
  }
  switch (error) {
    case /* Unauthorized */ 0 :
      return Curry._1(t.failure, error);
    case /* Forbidden */ 1 :
      return Curry._1(t.emit, {
        TAG: /* Personal_tokens */ 40,
        _0: {
          TAG: /* Failed */ 9,
          _0: "Your current permissions do not allow this token action."
        }
      });
    case /* Invalid_response */ 2 :
      return Curry._1(t.emit, {
        TAG: /* Personal_tokens */ 40,
        _0: {
          TAG: /* Failed */ 9,
          _0: "Invalid personal token response."
        }
      });
  }
}

function request(t, method_, body, path, error, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, method_, body, path).then(function (result) {
    if (generation === t.generation && Curry._1(t.model, undefined).personal_tokens !== undefined) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            failure(t, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        Curry._1(error, result._0);
      }
    }
    return Promise.resolve();
  });
}

function listing(t, more) {
  const cursor = Stdlib__Option.bind(Curry._1(t.model, undefined).personal_tokens, (function (p) {
    return p.cursor;
  }));
  const path = endpoint + (
    more ? Stdlib__Option.fold("", (function (id) {
        return "?after_id=" + id;
      }), cursor) : ""
  );
  request(t, undefined, undefined, path, (function (param) {
    return failure(t, param);
  }), (function (json) {
    const action_0 = Stdlib__Array.to_list(Stdlib__Array.map(Mapre_web__Web_personal_tokens_model.decode, Mapre_wire__Json.array(json, "personal_access_tokens")));
    const action_1 = Js__Js_json.decodeString(Mapre_wire__Json.get(json, "next_cursor"));
    const action = {
      TAG: /* Loaded */ 5,
      _0: action_0,
      _1: action_1,
      _2: more
    };
    Curry._1(t.emit, {
      TAG: /* Personal_tokens */ 40,
      _0: action
    });
  }));
}

function load(t, more) {
  cancel(t);
  Curry._1(t.emit, {
    TAG: /* Personal_tokens */ 40,
    _0: /* Loading */ 7
  });
  listing(t, more);
}

function creation_body(model, form) {
  const workspace = Stdlib__Option.get(Mapre_web__Web_types.workspace(model.route));
  return JSON.stringify(Js__Js_dict.fromList(Stdlib.$at({
    hd: [
      "request_id",
      Mapre_wire__Json.str(form.request_id)
    ],
    tl: {
      hd: [
        "name",
        Mapre_wire__Json.str(Stdlib__String.trim(form.name))
      ],
      tl: {
        hd: [
          "workspace_id",
          Mapre_wire__Json.str(workspace)
        ],
        tl: {
          hd: [
            "scopes",
            Stdlib__Array.of_list(Stdlib__List.map((function (s) {
              return Mapre_wire__Json.str(Mapre_web__Web_personal_tokens_model.scope_name(s));
            }), form.scopes))
          ],
          tl: {
            hd: [
              "expires_at",
              Date.now() + Stdlib__Option.get(Mapre_web__Web_personal_tokens_model.days(form.days)) * 86400000
            ],
            tl: /* [] */ 0
          }
        }
      }
    }
  }, form.project_only ? ({
      hd: [
        "project_id",
        Mapre_wire__Json.str(Stdlib__Option.get(Mapre_web__Web_types.project(model.route)))
      ],
      tl: /* [] */ 0
    }) : /* [] */ 0)));
}

function dispatch(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action === /* Close */ 0) {
      cancel(t);
      return Curry._1(t.emit, {
        TAG: /* Personal_tokens */ 40,
        _0: /* Close */ 0
      });
    }
    
  } else if (action.TAG === /* Open */ 0 && Curry._1(t.model, undefined).current_user !== undefined && Mapre_web__Web_types.workspace(Curry._1(t.model, undefined).route) !== undefined) {
    cancel(t);
    const action$1 = {
      TAG: /* Open */ 0,
      _0: crypto.randomUUID()
    };
    Curry._1(t.emit, {
      TAG: /* Personal_tokens */ 40,
      _0: action$1
    });
    return listing(t, false);
  }
  const form = Curry._1(t.model, undefined).personal_tokens;
  if (form === undefined) {
    return;
  }
  if (form.pending) {
    return;
  }
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Refresh */ 1 :
        if (form.loading) {
          return Curry._1(t.emit, {
            TAG: /* Personal_tokens */ 40,
            _0: action
          });
        } else {
          return load(t, false);
        }
      case /* More */ 2 :
        if (!form.loading && form.cursor !== undefined) {
          return load(t, true);
        } else {
          return Curry._1(t.emit, {
            TAG: /* Personal_tokens */ 40,
            _0: action
          });
        }
      case /* Fresh */ 3 :
        if (form.loading) {
          return Curry._1(t.emit, {
            TAG: /* Personal_tokens */ 40,
            _0: action
          });
        }
        cancel(t);
        const action$2 = {
          TAG: /* New */ 1,
          _0: crypto.randomUUID()
        };
        return Curry._1(t.emit, {
          TAG: /* Personal_tokens */ 40,
          _0: action$2
        });
      case /* Submit */ 5 :
        if (!Mapre_web__Web_personal_tokens_model.can_submit(form)) {
          return;
        }
        const body = form.claim;
        const body$1 = body !== undefined ? body : creation_body(Curry._1(t.model, undefined), form);
        Curry._1(t.emit, {
          TAG: /* Personal_tokens */ 40,
          _0: {
            TAG: /* Claim */ 4,
            _0: body$1
          }
        });
        return request(t, undefined, body$1, endpoint, (function (error) {
          if (/* tag */ typeof error !== "object" && typeof error !== "function") {
            return failure(t, error);
          }
          if (error.TAG !== /* Failed */ 1) {
            return failure(t, error);
          }
          if (error._0 !== "personal_token_secret_already_issued") {
            return failure(t, error);
          }
          Curry._1(t.emit, {
            TAG: /* Personal_tokens */ 40,
            _0: /* Secret_lost */ 8
          });
          listing(t, false);
        }), (function (json) {
          const action_0 = Mapre_web__Web_personal_tokens_model.decode(Mapre_wire__Json.get(json, "personal_access_token"));
          const action_1 = Mapre_wire__Json.string(json, "token");
          const action = {
            TAG: /* Created */ 6,
            _0: action_0,
            _1: action_1
          };
          Curry._1(t.emit, {
            TAG: /* Personal_tokens */ 40,
            _0: action
          });
        }));
      default:
        return Curry._1(t.emit, {
          TAG: /* Personal_tokens */ 40,
          _0: action
        });
    }
  } else {
    if (action.TAG !== /* Revoke */ 7) {
      return Curry._1(t.emit, {
        TAG: /* Personal_tokens */ 40,
        _0: action
      });
    }
    const id = action._0;
    if (!form.loading && Stdlib__List.exists((function (item) {
        return item.id === id ? !item.revoked : false;
      }), form.items)) {
      Curry._1(t.emit, {
        TAG: /* Personal_tokens */ 40,
        _0: /* Pending */ 6
      });
      return request(t, "DELETE", undefined, endpoint + ("/" + id), (function (param) {
        return failure(t, param);
      }), (function (json) {
        const action = {
          TAG: /* Revoked */ 8,
          _0: Mapre_web__Web_personal_tokens_model.decode(Mapre_wire__Json.get(json, "personal_access_token"))
        };
        Curry._1(t.emit, {
          TAG: /* Personal_tokens */ 40,
          _0: action
        });
      }));
    } else {
      return Curry._1(t.emit, {
        TAG: /* Personal_tokens */ 40,
        _0: action
      });
    }
  }
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
